import { render, staticRenderFns } from "./emotion.vue?vue&type=template&id=93debde4&"
import script from "./emotion.vue?vue&type=script&lang=js&"
export * from "./emotion.vue?vue&type=script&lang=js&"
import style0 from "./emotion.vue?vue&type=style&index=0&id=93debde4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports